import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Investors\CompanySuggestionController::__invoke
* @see app/Http/Controllers/Investors/CompanySuggestionController.php:16
* @route '//app.finesthub.de/companies/suggestions'
*/
const CompanySuggestionController = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: CompanySuggestionController.url(options),
    method: 'get',
})

CompanySuggestionController.definition = {
    methods: ["get","head"],
    url: '//app.finesthub.de/companies/suggestions',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Investors\CompanySuggestionController::__invoke
* @see app/Http/Controllers/Investors/CompanySuggestionController.php:16
* @route '//app.finesthub.de/companies/suggestions'
*/
CompanySuggestionController.url = (options?: RouteQueryOptions) => {
    return CompanySuggestionController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Investors\CompanySuggestionController::__invoke
* @see app/Http/Controllers/Investors/CompanySuggestionController.php:16
* @route '//app.finesthub.de/companies/suggestions'
*/
CompanySuggestionController.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: CompanySuggestionController.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Investors\CompanySuggestionController::__invoke
* @see app/Http/Controllers/Investors/CompanySuggestionController.php:16
* @route '//app.finesthub.de/companies/suggestions'
*/
CompanySuggestionController.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: CompanySuggestionController.url(options),
    method: 'head',
})

export default CompanySuggestionController